import InviteFriendsScreen from 'features/myVaro/screens/InviteFriends/InviteFriendsScreen';
import React from 'react';

export default function InviteFriendsPage() {
  return <InviteFriendsScreen />;
}
